module.exports = __webpack_public_path__ + "static/podcast-logo-b7025f94c02960645becb3b736fd1697.png";